<script>
import { mapState } from 'pinia';
import { useMessageStore } from '@/stores/message';
import Message from '@/components/Message.vue';
import Copyright from '../Copyright.vue';
import Version from '../Version.vue';

export default {
    computed: {
        ...mapState(useMessageStore, ['show']),
        years() {
            const year = new Intl.DateTimeFormat('en-US', { year: 'numeric' }).format(new Date());
            return `2024–${year}`
        }
    },
    components: {
        Message,
        Copyright,
        Version
    }
}
</script>

<template>
    <div class="flex flex-col items-center justify-center bg-green-500 min-h-screen gap-8 p-6 pb-10">
        <header>
            <router-link :to="{ name: 'login' }"
                class="sm:mx-auto sm:w-full sm:max-w-md flex flex-col items-center justify-center mb-2">
                <div class="bg-white rounded-full p-6 aspect-square mb-2 text-green-500 shadow-lg">
                    <span class="far fa-money-bill-trend-up text-7xl"></span>
                </div>
                <h1 class="text-5xl font-extrabold">In The <em>Green</em><sup class="text-xl">&trade;</sup></h1>
                <p class="text-white text-xl">Referral Group Tracker</p>
            </router-link>
        </header>

        <Message v-if="show" />

        <main class="bg-white py-8 px-4 shadow-lg rounded-lg sm:px-10 w-full sm:mx-auto sm:w-auto">
            <slot></slot>
        </main>

        <footer class="mt-16 flex flex-col items-center gap-8">
            <Version class="text-sm" />
            <p>Proudly developed and maintained by <a href="https://bizzynate.com"
                    class="underline hover:text-white">BizzyNate
                    Creative, Inc.</a>
            </p>
            <Copyright />
        </footer>
    </div>
</template>